import { render, staticRenderFns } from "./LandFillAreasReport.vue?vue&type=template&id=a61a5984"
import script from "./LandFillAreasReport.vue?vue&type=script&lang=js"
export * from "./LandFillAreasReport.vue?vue&type=script&lang=js"
import style0 from "./LandFillAreasReport.vue?vue&type=style&index=0&id=a61a5984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports